import request from '../../utils/request'
import deepCopy from '../../utils/deepCopy'
import objSort from '../../utils/objSort'
import intl from 'react-intl-universal'
import { Toast } from 'antd-mobile'
import React from 'react'
import config from '../../config'
// 公共函数
// 检测对象是否为空对象，是则返回true，否则返回false
export function isObjEmpty (obj) {
  for (const item in obj) {
    return false
  }
  return true
}
// 字符串或者数字前置补0
export function addZero (str, num) {
  let tmpStr = String(str)
  for (let len = tmpStr.length; len < num; len = tmpStr.length) {
    tmpStr = '0' + tmpStr
  }
  return tmpStr
}
// 获取今天+n天的日期。格式2019-08-26
export function getDateStr (AddDayCount) {
  const dt = new Date()
  dt.setDate(dt.getDate() + AddDayCount) // 获取AddDayCount天后的日期
  const y = addZero(dt.getFullYear(), 4)
  const m = addZero(dt.getMonth() + 1, 2) // 获取当前月份的日期
  const d = addZero(dt.getDate(), 2)
  return y + '/' + m + '/' + d
}
/** ****************************************** */
/** *******Order.js订餐页面初始化，获取餐次**************/
/** ***************************************** */
// 获取医院的基础配置信息
export function getPatientInfo (OrderMark, SessionContext) {
  // console.log('获取病人床位号+饮食医嘱+姓名')
  // console.log(SessionContext)
  const currentUser = SessionContext.currentUser
  const patientDTO = currentUser.patientDTO
  // console.log(patientDTO)
  if (patientDTO && JSON.stringify(patientDTO) !== '{}') {
    // 病人可以点餐的日期写入useContext
    const tmpArr = patientDTO.orderDateList || []
    // console.log(tmpArr)
    const tmpOrderDateList = tmpArr.map(item => item.substr(0, 10))
    // console.log(tmpOrderDateList)
    OrderMark.setOrderDateList(tmpOrderDateList)
    // 病人床位信息写入useContext
    const patientId = patientDTO.pid
    OrderMark.setPid(patientId)
    // 病人床位信息写入useContext
    const tmpPosition = patientDTO.patPositionName
    OrderMark.setPosition(tmpPosition)
    // 病人饮食医嘱写入useContext
    const tmpFoodAdvice = patientDTO.foodAdvices.map(item => item.advice)
    OrderMark.setFoodAdvice(tmpFoodAdvice.join('、'))
    // 病人姓名写入useContext
    const tmpPatientName = patientDTO.patientName
    OrderMark.setPatientName(tmpPatientName)
    const tmpOutHospitalTime = patientDTO.outHospitalTime !== null ? patientDTO.outHospitalTime.replace(/[T]/g, '').slice(0, 18) : ''
    OrderMark.setOutHospitalTime(tmpOutHospitalTime)
  }
}
// 获取营养餐和小锅菜的食物类型
export function getAllFoodType (OrderMark, Language) {
  request(`/v1/ordering/foodType`, {
    method: 'GET',
    headers: {
      'Accept-Language': Language.acceptLanguage
    }
  }).then((res) => {
    // console.log(res)
    if (res && res.data instanceof Array) {
      const foodTypeObj = JSON.parse(JSON.stringify(res.data)) || []
      const tmpfoodTypeObj = foodTypeObj.map(item => {
        if (item.spell) {
          const tmpStr = item.spell ? item.spell.toLocaleUpperCase() : 'Z'
          item.mySort = tmpStr.charCodeAt(0)
        }
        return item
      })
      tmpfoodTypeObj.length > 0 && tmpfoodTypeObj.sort(objSort('pid'))
      OrderMark.setYyFoodType(tmpfoodTypeObj)
      OrderMark.setXgFoodType(tmpfoodTypeObj)
    }
  }).catch((error) => {
    console.log(error)
  })
}
/***********************************************/
/** *******订餐页面的上面部分Order.js************/
/***********************************************/
export function updateMarkNum (OrderMark, OrderInfo, chooseDate, mealType, setMealTypeMarkObj = null) {
  // console.log(OrderMark.mealtypes)
  // console.log(OrderInfo)
  // console.log(chooseDate)
  // 更新当前日期、当前餐次的所有食物的份数
  const markArr = {}
  OrderMark.mealtypes.forEach(item => {
    markArr[`mealMark${item.id}`] = 0 // 属性不可以以数字开头， 所以前面加id
    OrderInfo.cacheAllFoodList.forEach(itemData => {
      if (item.id === itemData.mealTypeID && itemData.dayTime && chooseDate && itemData.dayTime.substr(0, 10).replace(/[-]/g, '') === chooseDate) {
        markArr[`mealMark${item.id}`] += itemData.selectedQuantity
      }
    })
  })
  // console.log(markArr)
  setMealTypeMarkObj !== null && setMealTypeMarkObj(markArr) // 将计算好的份数全部写进变量
  // 更新当前日期、餐次全部营养餐数量、全部小锅菜的数量
  let allYyFoodMark = 0
  let allXgFoodMark = 0
  OrderInfo.cacheAllFoodList.forEach(itemData => {
    if (mealType === itemData.mealTypeID && itemData.dayTime && chooseDate && itemData.dayTime.substr(0, 10).replace(/[-]/g, '') === chooseDate) {
      if (itemData.isPotFood === false) {
        allYyFoodMark += itemData.selectedQuantity
      } else {
        allXgFoodMark += itemData.selectedQuantity
      }
    }
  })
  OrderMark.setAllYyFoodMark(allYyFoodMark)
  OrderMark.setAllXgFoodMark(allXgFoodMark)
}
/***********************************************/
/** *******订餐页面的中间部分OrderTabs.js*********/
/***********************************************/
// 读缓存后更新订餐页面的份数
export function readFromCacheInOrderPage (OrderInfo, OrderMark, Language, xgFoodShowArr,yyFoodShowArr,setShowModal, setModalInfo, props, setYyFoodlist, setShowYyFoodlist, setXgFoodlist, setShowXgFoodlist, setShowCancel, setFlag, tabActive, setYyFoodTypeMarkObj, setXgFoodTypeMarkObj, setYyFoodShowArr, setXgFoodShowArr,setXgActive,setYyActive) {
  request(`/v1/order/cache`, {
    method: 'GET',
    headers: {
      'Accept-Language': Language.acceptLanguage
    }
  }).then((res) => {
    if (res.error) {
      setShowModal(true)
      setModalInfo(res.message)
    } else {
      // console.log(res.data)
      const tmpData = deepCopy(res.data)
      let tmpCacheFoodList = []
      if (tmpData.length > 0) {
        tmpCacheFoodList = tmpData.map(itemDatas => {
          itemDatas.allowOrder = 'allow'
          itemDatas.num = itemDatas.num === null ? 0 : itemDatas.num
          itemDatas.totalNum = itemDatas.totalNum === null ? -1 : itemDatas.totalNum
          if (itemDatas.isPotFood === false) {
            itemDatas.checkId = itemDatas.isSpecialAdvice ? itemDatas.foodID : itemDatas.foodMenuID
          } else {
            itemDatas.checkId = itemDatas.potFoodID
          }
          return itemDatas
        })
      }
      // 缓存读取成功，设置缓存，并设置标志位
      OrderInfo.setCacheAllFoodList(tmpCacheFoodList)
      OrderInfo.setIsOrderInfoEmpty(false)
      // 将缓存的数据同步到页面上
      const tmp = {
        cacheAllFoodList: tmpCacheFoodList
      }
      if (tabActive === 0) {
        getAllYyFoodList(props, tmp, OrderMark, Language, yyFoodShowArr,setYyFoodlist, setShowYyFoodlist, setShowModal, setModalInfo, setShowCancel, setFlag, setYyFoodTypeMarkObj, setYyFoodShowArr,setYyActive)
      } else {
        getAllXgFoodList(props, tmp, OrderMark, Language, xgFoodShowArr,setXgFoodlist, setShowXgFoodlist, setShowModal, setModalInfo, setFlag, setXgFoodTypeMarkObj, setXgFoodShowArr, setXgActive)
      }
    }
  }).catch((error) => {
    console.log(error)
  })
}

/** 获取OSS图片授权**/
export function getOssClient (OrderMark, Language) {
  request('/v1/oss/sts', {
    method: 'GET',
    headers: {
      'Accept-Language': Language.acceptLanguage
    }
  }).then((res) => {
    if (!res.error) {
      const OSS = require('ali-oss')
      const client = new OSS({
        region: config.ossRegion,
        accessKeyId: res._raw.credentials.accessKeyId,
        accessKeySecret: res._raw.credentials.accessKeySecret,
        bucket: config.ossBucket,
        endpoint: config.ossEndpoint,
        stsToken: res._raw.credentials.securityToken
      })
      // console.log('获取oss账户')
      // console.log(client)
      OrderMark.setOssClient(client)
    } else {
      console.log(res.message)
    }
  }).catch((error) => {
    console.log(error)
  })
}
/** * 获取OSS的sts账户信息   */
export function getOssImg (OrderMark, foodsInfo, Language, setFoodInfo, setFoodInfo2 = null) {
  if (OrderMark.ossClient !== '') {
    // console.log('获取到OSS账户了')
    let tmpFoodInfo = []
    if (foodsInfo.length > 0) {
      tmpFoodInfo = foodsInfo.map(item => {
        if (item.isPotFood === false || item.isPotFood === 1) {
          if (item.picID && OrderMark.ossClient && OrderMark.ossClient.signatureUrl !== undefined) {
            item.picAddress = OrderMark.ossClient.signatureUrl(item.picID, {
              expires: 43200
            })
          }
        }
        if (item.isPotFood === true || item.isPotFood === 0) {
          if (item.food && OrderMark.ossClient && item.food.picID && OrderMark.ossClient.signatureUrl !== undefined) {
            item.picAddress = OrderMark.ossClient.signatureUrl(item.food.picID, {
              expires: 43200
            })
          }
        }
        if (item.picAddress === '') {
          if (item.picID && OrderMark.ossClient && OrderMark.ossClient.signatureUrl !== undefined) {
            item.picAddress = OrderMark.ossClient.signatureUrl(item.picID, {
              expires: 43200
            })
          }
        }
        return item
      })
    }
    // console.log(tmpFoodInfo)
    setFoodInfo(tmpFoodInfo)
    if (setFoodInfo2 !== null) {
      setFoodInfo2(tmpFoodInfo)
    }
  } else {
    if (window.localStorage.getItem('sdxUUID')) {
      request('/v1/oss/sts', {
        method: 'GET',
        headers: {
          'Accept-Language': Language.acceptLanguage
        }
      }).then((res) => {
        if (!res.error) {
          const OSS = require('ali-oss')
          const client = new OSS({
            region: 'oss-cn-shanghai',
            accessKeyId: res._raw.credentials.accessKeyId,
            accessKeySecret: res._raw.credentials.accessKeySecret,
            bucket: 'sodexo-pfs-wechat',
            endpoint: 'https://oss-cn-shanghai.aliyuncs.com',
            stsToken: res._raw.credentials.securityToken
          })
          // console.log(foodsInfo)
          OrderMark.setOssClient(client)
          let tmpFoodInfo = []
          if (foodsInfo.length > 0) {
            tmpFoodInfo = foodsInfo.map((item) => {
              if (item.isPotFood === false || item.isPotFood === 1) {
                if (item.picID && client.signatureUrl !== undefined) {
                  item.picAddress = client.signatureUrl(item.picID, {
                    expires: 43200
                  })
                }
              }
              if (item.isPotFood === true || item.isPotFood === 0) {
                if (item.food && item.food.picID && client.signatureUrl !== undefined) {
                  item.picAddress = client.signatureUrl(item.food.picID, {
                    expires: 43200
                  })
                }
              }
              if (item.picAddress === '') {
                if (item.picID && client.signatureUrl !== undefined) {
                  item.picAddress = client.signatureUrl(item.picID, {
                    expires: 43200
                  })
                }
              }
              return item
            })
          }
          // console.log(tmpFoodInfo)
          setFoodInfo(tmpFoodInfo)
          if (setFoodInfo2 !== null) {
            setFoodInfo2(tmpFoodInfo)
          }
        } else {
          console.log(res.message)
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  }
}
/**
 * 检验这个病人是否已经点过了营养餐
 * PFS端和PAD端用新设计的图片
 * 微信端用旧的提示
 * @param {Function} setFlag 设置OrderTab的flag
 */
async function verifyOrder (dayTime, mealType, setFlag, Language) {
  const res = await request(`/v1/order/food/${dayTime}/${mealType}`, {
    method: 'GET',
    headers: {
      'Accept-Language': Language.acceptLanguage
    }
  })
  if (res.data && res.data.length > 0) {
    let endPoint = 'wx'
    for (let i = 0; i < res.data.length; i++) {
      if (Number(res.data[i].device) === 99) {
        endPoint = 'PFS'
        break
      } else if (res.data[i].device === 'pad') {
        endPoint = 'PAD'
      }
    }
    if (endPoint === 'PAD') {
      setFlag('getAllYyFood_verifyOrderError_pad') // 病员已经点了营养餐(pad端)
      return false
    } else if (endPoint === 'PFS') {
      setFlag('getAllYyFood_verifyOrderError_PFS') // 病员已经点了营养餐(pfs端)
      return false
    }
    return true
  } else {
    return true
  }
}

// 请求该日期餐次下的所有营养餐的食物列表(缓存的点餐数字需要保留)
export async function getAllYyFoodList (props, OrderInfo, OrderMark, Language, yyFoodShowArr,setYyFoodlist, setShowYyFoodlist, setShowModal, setModalInfo, setShowCancel, setFlag, setYyFoodTypeMarkObj, setYyFoodShowArr, setYyActive) {
  const dayTime = props.chooseDate.slice(0, 4) + '-' + props.chooseDate.slice(4, 6) + '-' + props.chooseDate.slice(6)
  const verifyRes = await verifyOrder(dayTime, props.mealType, setFlag, Language)
  if (!verifyRes) {
    return false
  }
  let timeout = false
  let getRes = false
  const timeClock = setTimeout(() => {
    if (!getRes) {
      timeout = true
      Toast.hide()
      setShowModal(true)
      setModalInfo(intl.get('checkNetwork'))
    }
  }, 10000)
  Toast.loading(intl.get('Loading...'), 0)
  // Toast.loading(intl.get('Loading...'), 0.5, () => {}, false)
  request(`/v1/ordering/food?dayTime=${props.chooseDate.slice(0, 4)}%2F${props.chooseDate.slice(4, 6)}%2F${props.chooseDate.slice(6)}&mealType=${props.mealType}`, {
    method: 'GET',
    headers: {
      'Accept-Language': Language.acceptLanguage
    }
  }).then((res) => {
    clearTimeout(timeClock)
    if (!timeout) {
      getRes = true
      Toast.hide()
      // console.log(res)
      if (res.error) {
        const tmpMessage = res.message
        if (res.code === '1001') {
          setFlag('getAllYyFood_1001') // 病员由营养师配餐
        } else if (res.code === '1002') {
          setFlag('getAllYyFood_1002') // 饮食医嘱为禁食，病员无法点餐
        } else if (res.code === '1003') {
          setFlag('getAllYyFood_1003')// 该餐次的医嘱餐已下单
        } else if (res.code === '1004') {
          setFlag('getAllYyFood_1004')// 清联系营养师配餐
        } else if (res.code === '1005') {
          setFlag('getAllYyFood_1005')// 病人饮食自理
        } else {
          setShowModal(true)
          setModalInfo(tmpMessage)
        }
        // Toast.hide()
      } else {
        // Toast.hide()
        const yyFoodListObj = deepCopy(res.data) || []
        if (yyFoodListObj.length === 0) {
          setFlag('getAllYyFood_noFood')
        }
        yyFoodListObj.length > 0 && yyFoodListObj.sort(objSort('sort'))
        // console.log(yyFoodListObj)
        const tmpYyFoodListObj = yyFoodListObj.map(itemDatas => {
          itemDatas.num = itemDatas.num === null ? 0 : itemDatas.num
          itemDatas.totalNum = itemDatas.totalNum === null ? -1 : itemDatas.totalNum
          itemDatas.selectedQuantity = 0
          itemDatas.isPotFood = false
          itemDatas.foodID = itemDatas.id
          itemDatas.typeID = itemDatas.type_ID
          itemDatas.picAddress = '' // 前端新增
          itemDatas.mealTypeID = itemDatas.mealTypeID === null ? props.mealType : itemDatas.mealTypeID
          itemDatas.isSpecialAdvice = itemDatas.py && itemDatas.py.indexOf('XXXSPEXXX') >= 0
          itemDatas.checkId = itemDatas.isSpecialAdvice ? itemDatas.foodID : itemDatas.foodMenuID
          if (itemDatas.dayTime === null || itemDatas.dayTime === '') {
            itemDatas.dayTime = dayTime
          }
          // 当在Ordefined.js页面直接刷新，返回到order.js页面，这时候前端缓存不变，会导致order.js这里不更新食物已经点的份数，所以这里加代码
          OrderInfo.cacheAllFoodList.forEach(item => {
            if (item.isPotFood === false && item.dayTime && itemDatas.dayTime && item.dayTime.substr(0, 10).replace(/[-]/g, '') === itemDatas.dayTime.substr(0, 10).replace(/[-]/g, '') && item.mealTypeID === itemDatas.mealTypeID && item.checkId === itemDatas.checkId) {
              itemDatas.selectedQuantity = item.selectedQuantity
            }
          })
          return itemDatas
        })
        if (tmpYyFoodListObj.length === 1 && tmpYyFoodListObj[0].py && tmpYyFoodListObj[0].py.indexOf('XXXSPEXXX') >= 0) {
          // 如果检测到获取的食物列表只有一份，需要检查是否是特殊饮食，如果是则返回一个变量，接收参数后，显示一个提示框
          let flag = true
          OrderInfo.cacheAllFoodList.forEach(item => {
            if (item.isPotFood === false && item.dayTime && tmpYyFoodListObj[0].dayTime && item.dayTime.substr(0, 10).replace(/[-]/g, '') === tmpYyFoodListObj[0].dayTime.substr(0, 10).replace(/[-]/g, '') && item.mealTypeID === tmpYyFoodListObj[0].mealTypeID && item.checkId === tmpYyFoodListObj[0].checkId) {
              item.selectedQuantity > 0 && (flag = false)
            }
          })
          if (flag) {
            setFlag('XXXSPEXXX')
            setShowModal(true)
            setShowCancel(true)
            setModalInfo(<div>
              <div className='tc lh1-5'>{intl.get('Need a special treatment meal?')}</div>
              <div className='tc lh1-5'>{intl.get('Price:')}&yen;{tmpYyFoodListObj[0].unitPrice}/{intl.get('proportion')}</div>
            </div>)
          }
        }
        // console.log(tmpYyFoodListObj)
        // 获取食物的图片
        // console.log('获取营养餐食物的图片')
        updateYyTypeMarkNum(OrderMark, OrderInfo, props, setYyFoodTypeMarkObj)// 更新该营养餐类型已经点的份数
        updateYyTypeShow(OrderMark, tmpYyFoodListObj, setYyFoodShowArr, setYyActive, setShowYyFoodlist, tmpYyFoodListObj)
        getOssImg(OrderMark, tmpYyFoodListObj, Language, setYyFoodlist, setShowYyFoodlist)
        // setYyFoodlist(tmpYyFoodListObj)
        // setShowYyFoodlist(tmpYyFoodListObj)
      }
    
    } else {
      getRes = false
    }
  }).catch((error) => {
    clearTimeout(timeClock)
    Toast.hide()
    setShowModal(true)
    setModalInfo(intl.get('unknownError'))
    console.log(error)
  })
}
// 请求该日期餐次下的所有小锅菜的食物列表(小锅菜获取只和日期相关，但是写入context要标注餐次)
export async function getAllXgFoodList (props, OrderInfo, OrderMark, Language, xgFoodShowArr, setXgFoodlist, setShowXgFoodlist, setShowModal, setModalInfo, setFlag, setXgFoodTypeMarkObj, setXgFoodShowArr, setXgActive) {
  const dayTime = props.chooseDate.slice(0, 4) + '-' + props.chooseDate.slice(4, 6) + '-' + props.chooseDate.slice(6)
  let timeout = false
  let getRes = false
  const timeClock = setTimeout(() => {
    if (!getRes) {
      timeout = true
      Toast.hide()
      setShowModal(true)
      setModalInfo(intl.get('checkNetwork'))
    }
  }, 10000)
  Toast.loading(intl.get('Loading...'), 0)
  // Toast.loading(intl.get('Loading...'), 0.5, () => { }, false)
  request(`/v1/ordering/potFood?dayTime=${props.chooseDate.slice(0, 4)}%2F${props.chooseDate.slice(4, 6)}%2F${props.chooseDate.slice(6)}&mealType=${props.mealType}`, {
    method: 'GET',
    headers: {
      'Accept-Language': Language.acceptLanguage
    }
  }).then((res) => {
    // console.log(props.mealType)
    // console.log(props.chooseDate)
    // console.log(OrderInfo)
    clearTimeout(timeClock)
    if (!timeout) {
      getRes = true
      Toast.hide()
      if (res.error) {
        setShowModal(true)
        setModalInfo(res.message)
        // Toast.hide()
      } else {
        // Toast.hide()
        const xgFoodListObj = deepCopy(res.data) || []
        if (xgFoodListObj.length === 0) {
          setFlag('getAllXgFood_noFood')
        }
        const tmpXgFoodListObj = xgFoodListObj.map(itemDatas => {
          // console.log(itemDatas)
          itemDatas.num = itemDatas.num === null ? 0 : itemDatas.num
          itemDatas.totalNum = itemDatas.totalNum === null ? -1 : itemDatas.totalNum
          itemDatas.selectedQuantity = 0
          itemDatas.isPotFood = true
          itemDatas.foodID = itemDatas.food_ID
          itemDatas.potFoodID = itemDatas.id
          itemDatas.checkId = itemDatas.id
          itemDatas.typeID = itemDatas.food ? itemDatas.food.type_ID : ''
          itemDatas.dayTime = dayTime
          itemDatas.foodName = itemDatas.food ? itemDatas.food.foodName : ''
          itemDatas.unitPrice = itemDatas.food ? itemDatas.food.unitPrice : ''
          itemDatas.picAddress = '' // 前端新增
          itemDatas.mealTypeID = props.mealType
          itemDatas.isSpecialAdvice = itemDatas.food && itemDatas.food.py && itemDatas.food.py.indexOf('XXXSPEXXX') >= 0 // 前端新增
          // 当在Ordefined.js页面直接刷新，返回到order.js页面，这时候前端缓存不变，会导致order.js这里不更新食物已经点的份数，所以这里加代码
          OrderInfo.cacheAllFoodList.forEach(item => {
            if (item.isPotFood === true && item.dayTime && itemDatas.dayTime && item.dayTime.substr(0, 10).replace(/[-]/g, '') === itemDatas.dayTime.substr(0, 10).replace(/[-]/g, '') && item.mealTypeID === itemDatas.mealTypeID && item.checkId === itemDatas.checkId) {
              itemDatas.selectedQuantity = item.selectedQuantity
            }
          })
          return itemDatas
        })
        // console.log(tmpXgFoodListObj)
        // 获取食物的图片
        // console.log('获取小锅菜食物的图片')
        updateXgTypeMarkNum(OrderMark, OrderInfo, props, setXgFoodTypeMarkObj)// 更新该小锅菜类型已经点的份数
        updateXgTypeShow(OrderMark, tmpXgFoodListObj, setXgFoodShowArr)
        getOssImg(OrderMark, tmpXgFoodListObj, Language, setXgFoodlist, setShowXgFoodlist)
        // setXgFoodlist(tmpXgFoodListObj)
        // setShowXgFoodlist(tmpXgFoodListObj)

        if(JSON.stringify(xgFoodShowArr) ==='{}'){
    
        }else{
          for (let i = 0; i < OrderMark.xgFoodType.length; i++)
          {
            if(xgFoodShowArr[`xgTypeShow${OrderMark.xgFoodType[i].id}`]){
              setXgActive(OrderMark.xgFoodType[i].id)
              setShowXgFoodlist(tmpXgFoodListObj.filter(item => {
                return item.food && item.food.type_ID === OrderMark.xgFoodType[i].id
              }))    
              break;
            }
          }
        }


      }
    } else {
      getRes = false
    }
  }).catch((error) => {
    clearTimeout(timeClock)
    Toast.hide()
    setShowModal(true)
    setModalInfo(intl.get('unknownError'))
    console.log(error)
  })
}
// 从缓存获取营养餐和小锅菜的食物数量，并同步到页面
export function updateFoodNumByCache (OrderInfo, yyFoodlist, setYyFoodlist, showYyFoodlist, setShowYyFoodlist, xgFoodlist, setXgFoodlist, showXgFoodlist, setShowXgFoodlist) {
  // 更新营养餐的食物数量
  const yyFoodListObj = deepCopy(yyFoodlist) || []
  yyFoodListObj.length > 0 && yyFoodListObj.sort(objSort('sort'))
  const tmpYyFoodListObj = yyFoodListObj.map((itemDatas) => {
    itemDatas.selectedQuantity = 0
    OrderInfo.cacheAllFoodList.forEach(item => {
      if (item.isPotFood === false && item.dayTime && itemDatas.dayTime && item.dayTime.substr(0, 10).replace(/[-]/g, '') === itemDatas.dayTime.substr(0, 10).replace(/[-]/g, '') && item.mealTypeID === itemDatas.mealTypeID && item.checkId === itemDatas.checkId) {
        itemDatas.selectedQuantity = item.selectedQuantity
      }
    })
    return itemDatas
  })
  const tmpShowYyFoodListObj = showYyFoodlist.map((itemDatas) => {
    // console.log(itemDatas)
    itemDatas.selectedQuantity = 0
    OrderInfo.cacheAllFoodList.forEach(item => {
      if (item.isPotFood === false && item.dayTime && itemDatas.dayTime && item.dayTime.substr(0, 10).replace(/[-]/g, '') === itemDatas.dayTime.substr(0, 10).replace(/[-]/g, '') && item.mealTypeID === itemDatas.mealTypeID && item.checkId === itemDatas.checkId) {
        itemDatas.selectedQuantity = item.selectedQuantity
      }
    })
    return itemDatas
  })
  setYyFoodlist(tmpYyFoodListObj)
  setShowYyFoodlist(tmpShowYyFoodListObj)
  // 更新小锅菜的食物数量
  const xgFoodListObj = deepCopy(xgFoodlist) || []
  xgFoodListObj.length > 0 && xgFoodListObj.sort(objSort('sort'))
  const tmpXgFoodListObj = xgFoodListObj.map(itemDatas => {
    itemDatas.selectedQuantity = 0
    OrderInfo.cacheAllFoodList.forEach(item => {
      if (item.isPotFood && item.dayTime && itemDatas.dayTime && item.dayTime.substr(0, 10).replace(/[-]/g, '') === itemDatas.dayTime.substr(0, 10).replace(/[-]/g, '') && item.mealTypeID === itemDatas.mealTypeID && item.checkId === itemDatas.checkId) {
        itemDatas.selectedQuantity = item.selectedQuantity
      }
    })
    return itemDatas
  })
  const tmpShowXgFoodListObj = showXgFoodlist.map(itemDatas => {
    itemDatas.selectedQuantity = 0
    OrderInfo.cacheAllFoodList.forEach(item => {
      if (item.isPotFood && item.dayTime && itemDatas.dayTime && item.dayTime.substr(0, 10).replace(/[-]/g, '') === itemDatas.dayTime.substr(0, 10).replace(/[-]/g, '') && item.mealTypeID === itemDatas.mealTypeID && item.checkId === itemDatas.checkId) {
        itemDatas.selectedQuantity = item.selectedQuantity
      }
    })
    return itemDatas
  })
  setXgFoodlist(tmpXgFoodListObj)
  setShowXgFoodlist(tmpShowXgFoodListObj)
}
// 当点击食物的减时候
export function foodDecrease (itemData, OrderInfo) {
  const tmpCacheAllFoodList = OrderInfo.cacheAllFoodList.map(item => {
    if (item.isPotFood === itemData.isPotFood && item.dayTime && itemData.dayTime && item.dayTime.substr(0, 10).replace(/[-]/g, '') === itemData.dayTime.substr(0, 10).replace(/[-]/g, '') && item.mealTypeID === itemData.mealTypeID && item.checkId === itemData.checkId) {
      item.selectedQuantity -= 1
    }
    return item
  })
  // console.log(tmpCacheAllFoodList)
  // 过滤出那些数量大于0的食物(客户要求显示0)
  // const tmp = tmpCacheAllFoodList.length > 0 ? tmpCacheAllFoodList.filter(item => {
  //   return item.selectedQuantity > 0
  // }) : []
  OrderInfo.setCacheAllFoodList(tmpCacheAllFoodList)
  OrderInfo.setIsOrderInfoEmpty(false)
  // console.log(OrderInfo.cacheAllFoodList)
}

// 测试下一份营养餐是否已经是最大份数
export function foodTestForMax (itemData) {
  let addOperation = false
  if (itemData && itemData.totalNum !== -1) { // 如果不等于-1表示营养餐份数是有限制的，需要校验份数在此校验份数（当前已点+后台已点）是否超过总份数
    if (itemData.num >= itemData.totalNum) { // 该营养餐超过了当天的最大份数
      addOperation = true // 不允许再继续增加营养餐，后面增加代码不在执行
    }
  }
  return addOperation
}
// 测试下一份小锅菜是否已经达到了最大份数
export function addFoodTestForMax (itemData, OrderInfo, date) {
  let addOperation = false
  if (itemData && itemData.totalNum !== -1) { // 如果不等于-1表示食物有限制的，需要校验份数在此校验份数（当前已点+后台已点）是否超过总份数
    let xgNumPerDay = 0
    OrderInfo.cacheAllFoodList.forEach(cacheItem => {
      // console.log(cacheItem.dayTime)
      if (cacheItem.isPotFood && cacheItem.dayTime && date.substr(0, 10).replace(/[-]/g, '') === cacheItem.dayTime.substr(0, 10).replace(/[-]/g, '') && cacheItem.checkId === itemData.checkId) {
        xgNumPerDay += cacheItem.selectedQuantity
      }
    })
    if (xgNumPerDay + itemData.num >= itemData.totalNum) { // 食物超过了当天的最大份数
      addOperation = true // 不允许在继续增加今天该份食物
    }
  }
  return addOperation
}
// 点击显示菜谱描述
export function handleOnShowModel(value, setShowMenuModal, setModalInfo, setModalTitle, setModalOkButton) {
  setModalInfo(<div style={{maxHeight: '100%', overflow: 'hidden', overflowY: 'auto'}}>{value}</div>)
  setModalTitle(intl.get('Recipe details'))
  setModalOkButton(<div style={{ width: '30%', height: '45%' }} className={'okButton'}>{intl.get('close')}</div>)
  setShowMenuModal(true)
}
// 当点击食物加时候
export function foodIncrease (itemData, OrderInfo, setShowModal, setModalInfo, date, OrderMark = []) {
  // console.log(itemData)
  // console.log(OrderMark.mealtypes)
  // console.log(OrderInfo)
  // console.log(date)
  // console.log(OrderMark.yyFoodType)
  if (!(typeof (OrderMark.position) === 'string' && OrderMark.position)) {
    // 如果床位信息不是字符串或者是空字符串就不能点餐
    setModalInfo(intl.get('The patient bed information is empty, no ordering.'))
    setShowModal(true)
    return false
  }
  let addOperation = true
  if (!itemData.isPotFood) { // 营养餐的校验
    if (OrderMark !== [] && !isObjEmpty(OrderMark.properties) && OrderMark.properties.isFoodGang) { // 营养餐包伙制时候，每个类型最多只能点一份
      if (itemData.totalNum !== -1 && itemData.totalNum !== null && itemData.num >= itemData.totalNum) {
        setShowModal(true)
        setModalInfo(intl.get('The meal package has reached the maximum servings.'))
        addOperation = false // 该包伙制营养餐已售罄，不可再点
      } else {
        OrderInfo.cacheAllFoodList.forEach(item => {
          // console.log(item)
          if (!item.isPotFood && item.dayTime && itemData.dayTime && item.dayTime.substr(0, 10).replace(/[-]/g, '') === itemData.dayTime.substr(0, 10).replace(/[-]/g, '') && item.mealTypeID === itemData.mealTypeID && item.typeID === itemData.typeID) {
            if (item.selectedQuantity >= 1) {
              setShowModal(true)
              setModalInfo(intl.get('Limit one serving per meal for the same type of food.'))
              addOperation = false // 不允许再继续增加营养餐，后面增加代码不在执行
            }
          }
        })
      }
    } else { // 营养餐非包伙制的情况（微信收钱，可以退餐）
      if (itemData.isSpecialAdvice) {
        const overOne = OrderInfo.cacheAllFoodList.some(item => {
          return item.isPotFood === false && item.dayTime && itemData.dayTime && item.isSpecialAdvice &&
            item.dayTime.substr(0, 10).replace(/[-]/g, '') === itemData.dayTime.substr(0, 10).replace(/[-]/g, '') &&
            item.mealTypeID === itemData.mealTypeID && item.checkId === itemData.checkId && item.selectedQuantity
        })
        if (overOne) {
          setShowModal(true)
          setModalInfo(intl.get('Limit one serving per meal.'))
          addOperation = false
        }
      } else {
        if (itemData.totalNum !== -1 && itemData.totalNum !== null) { // 如果不等于-1表示营养餐份数是有限制的，需要校验份数在此校验份数（当前已点+后台已点）是否超过总份数
          let yyNumPerMeal = 0
          OrderInfo.cacheAllFoodList.forEach(item => {
            if (item.isPotFood === false && item.dayTime && itemData.dayTime && item.py !== 'XXXSPEXXX' && item.dayTime.substr(0, 10).replace(/[-]/g, '') === itemData.dayTime.substr(0, 10).replace(/[-]/g, '') && item.mealTypeID === itemData.mealTypeID && item.checkId === itemData.checkId) {
              yyNumPerMeal += item.selectedQuantity
            }
          })
          if (yyNumPerMeal + itemData.num >= itemData.totalNum) { // 该营养餐超过了当天的最大份数
            setShowModal(true)
            setModalInfo(intl.get('The meal package has reached the maximum servings.'))
            addOperation = false // 不允许再继续增加营养餐，后面增加代码不在执行
          }
        }
      }
    }
  } else {
    if (itemData.totalNum !== -1 && itemData.totalNum !== null) { // 如果不等于-1表示小锅菜份数是有限制的，需要校验份数在此校验份数（当前已点+后台已点）是否超过总份数
      let xgNumPerDay = 0
      OrderInfo.cacheAllFoodList.forEach(cacheItem => {
        // console.log(cacheItem.dayTime)
        if (cacheItem.isPotFood && cacheItem.dayTime && date.substr(0, 10).replace(/[-]/g, '') === cacheItem.dayTime.substr(0, 10).replace(/[-]/g, '') && cacheItem.checkId === itemData.checkId) {
          xgNumPerDay += cacheItem.selectedQuantity
        }
      })
      if (xgNumPerDay + itemData.num >= itemData.totalNum) { // 小锅菜超过了当天的最大份数
        setShowModal(true)
        setModalInfo(intl.get('The small pot dishes have reached the maximum number.'))
        addOperation = false // 不允许在继续增加今天小锅菜，后面增加代码不在执行
      }
    }
  }
  if (addOperation) { // 前面的校验都通过，则增加营养餐或者小锅菜
    var flag = false
    // console.log(OrderInfo.cacheAllFoodList)
    const tmpCacheAllFoodList = OrderInfo.cacheAllFoodList.map(item => {
      if (item.isPotFood === itemData.isPotFood && item.dayTime && itemData.dayTime && item.dayTime.substr(0, 10).replace(/[-]/g, '') === itemData.dayTime.substr(0, 10).replace(/[-]/g, '') && item.mealTypeID === itemData.mealTypeID && item.checkId === itemData.checkId) {
        item.selectedQuantity += 1
        flag = true
      }
      return item
    })
    if (flag) {
      OrderInfo.setCacheAllFoodList(tmpCacheAllFoodList)
      OrderInfo.setIsOrderInfoEmpty(false)
    } else {
      const item = deepCopy(itemData)
      // console.log(item)
      const tmpItem = {
        dayTime: item.dayTime,
        foodID: item.foodID,
        mealTypeID: item.mealTypeID,
        selectedQuantity: item.selectedQuantity,
        sort: item.sort,
        totalNum: item.totalNum,
        num: item.num,
        isPotFood: item.isPotFood,
        typeID: item.typeID,
        foodName: item.foodName,
        unitPrice: item.unitPrice,
        isSpecialAdvice: item.isSpecialAdvice,
        allowOrder: 'allow',
        checkId: item.checkId
      }
      if (item.isPotFood === false) {
        tmpItem.foodMenuID = tmpItem.isSpecialAdvice ? '' : item.foodMenuID
      } else {
        tmpItem.potFoodID = item.potFoodID
      }
      tmpItem.selectedQuantity += 1
      const tmp = OrderInfo.cacheAllFoodList.length > 0 ? deepCopy(OrderInfo.cacheAllFoodList) : []
      tmp.push(tmpItem)
      // console.log(tmp)
      OrderInfo.setCacheAllFoodList(tmp)
    }
    // console.log(OrderInfo.cacheAllFoodList)
  }
}
// 只显示有菜的营养餐类型
export function updateYyTypeShow (OrderMark, yyFoodlist, setYyFoodShowArr, setYyActive, setShowYyFoodlist, tmpYyFoodListObj) {
  const yyFoodShowArr = {}
  // 过滤出有营养餐食物的类型
  OrderMark.yyFoodType.forEach(yyItem => {
    const yyFilterArr = yyFoodlist.filter(yyItemData => yyItemData.type_ID === yyItem.id)
    yyFoodShowArr[`yyTypeShow${yyItem.id}`] = yyFilterArr.length > 0
  })
  // console.log(yyFoodShowArr)
  setYyFoodShowArr(yyFoodShowArr)
  if(JSON.stringify(yyFoodShowArr) ==='{}'|| OrderMark.yyFoodlist === []){
  }else{
    for (let i = 0; i < OrderMark.yyFoodType.length; i++)
    {
      if(yyFoodShowArr[`yyTypeShow${OrderMark.yyFoodType[i].id}`]){
        setYyActive(OrderMark.yyFoodType[i].id)
        setShowYyFoodlist(tmpYyFoodListObj.filter(item => {
          return item.type_ID === OrderMark.yyFoodType[i].id
        }))
        console.log('我是新增的数据', OrderMark.yyFoodType[i].id) 
        break;
      }
    }
  }
}
// 只显示有菜的小锅菜类型
export function updateXgTypeShow (OrderMark, xgFoodlist, setXgFoodShowArr) {
  const xgFoodShowArr = {}
  // 过滤出有营养餐食物的类型
  OrderMark.xgFoodType.forEach(xgItem => {
    const xgFilterArr = xgFoodlist.filter(xgItemData => xgItemData.food && xgItemData.food.type_ID === xgItem.id)
    xgFoodShowArr[`xgTypeShow${xgItem.id}`] = xgFilterArr.length > 0
  })
  setXgFoodShowArr(xgFoodShowArr)
}
// 更新营养餐左侧的食物类型的左上角的数字小标记mark
export function updateYyTypeMarkNum (OrderMark, OrderInfo, props, setYyFoodTypeMarkObj) {
  const yyFoodMarkArr = {}
  OrderMark.yyFoodType.forEach(yyItem => {
    yyFoodMarkArr[`yyTpyeMark${yyItem.id}`] = 0 // 属性不可以以数字开头， 所以前面加id
    OrderInfo.cacheAllFoodList.forEach(item => {
      if (item.isPotFood === false && yyItem.id === item.typeID && item.mealTypeID === props.mealType && item.dayTime && props.chooseDate && item.dayTime.substr(0, 10).replace(/[-]/g, '') === props.chooseDate.substr(0, 10).replace(/[-]/g, '')) {
        yyFoodMarkArr[`yyTpyeMark${yyItem.id}`] += item.selectedQuantity
      }
    })
  })
  // console.log(yyFoodMarkArr)
  setYyFoodTypeMarkObj(yyFoodMarkArr)
}
// 更新小锅菜左侧的食物类型的左上角的数字小标记mark
export function updateXgTypeMarkNum (OrderMark, OrderInfo, props, setXgFoodTypeMarkObj) {
  const xgFoodMarkArr = {}
  OrderMark.xgFoodType.forEach(xgItem => {
    xgFoodMarkArr[`xgTypeMark${xgItem.id}`] = 0 // 属性不可以以数字开头， 所以前面加id
    OrderInfo.cacheAllFoodList.forEach(itemData => {
      if (itemData.isPotFood === true && xgItem.id === itemData.typeID && itemData.mealTypeID === props.mealType && itemData.dayTime && props.chooseDate && itemData.dayTime.substr(0, 10).replace(/[-]/g, '') === props.chooseDate.substr(0, 10).replace(/[-]/g, '')) {
        xgFoodMarkArr[`xgTypeMark${xgItem.id}`] += itemData.selectedQuantity
      }
    })
  })
  // console.log(xgFoodMarkArr)
  setXgFoodTypeMarkObj(xgFoodMarkArr)
}
/***********************************************/
/** *******订餐页面的下方OrderShopping.js*********/
/***********************************************/
/** **********获取最近的可选餐次****************** */
export function getEnAbleMealTypes (mealTypes, chooseDate, advanceDay, outHospitalTime) {
  const tmpoutHospitalDate = outHospitalTime && outHospitalTime.substr(0, 10).replace(/[-]/g, '')
  const tmpoutHospitalTime = outHospitalTime && outHospitalTime.substr(10, 8).replace(/[:]/g, '')
  const showObj = {}
  mealTypes.forEach(item => {
    // console.log(item)
    if (tmpoutHospitalDate && chooseDate && item.mealTime && chooseDate === tmpoutHospitalDate && Number(item.mealTime.replace(/[:]/g, '')) > Number(tmpoutHospitalTime)) {
      showObj[`mealShow${item.id}`] = false
    } else {
      showObj[`mealShow${item.id}`] = true
    }
  })
  let defaultMealType = ''
  const tmpEnableMeals = []
  const date = getDateStr(advanceDay)
  const dt = new Date()
  const time = addZero(dt.getHours(), 2) + ':' + addZero(dt.getMinutes(), 2) + ':' + addZero(dt.getSeconds(), 2)
  const nowDateTimeObj = new Date(date + ' ' + time)
  // console.log(chooseDate)
  if (chooseDate && date && chooseDate.substr(0, 10).replace(/[-]/g, '') === date.substr(0, 10).replace(/[/]/g, '')) { // 点餐日期等于基准日期
    mealTypes.forEach(item => {
      // console.log(item)
      const mealDateTimeObj = new Date(date + ' ' + item.orderDeadLine)
      if (nowDateTimeObj.getTime() < mealDateTimeObj.getTime()) {
        showObj[`mealShow${item.id}`] === true && tmpEnableMeals.push(item.id) // 去除过期餐次 + 去除因为病人出院时间限制导致的不可点餐的餐次
      }
    })
    defaultMealType = tmpEnableMeals.length ? tmpEnableMeals[0] : ''
  } else if (chooseDate && date && Number(chooseDate.substr(0, 10).replace(/[-]/g, '')) > Number(date.substr(0, 10).replace(/[/]/g, ''))) { // 点餐日期在基准日期之后
    const newMealtypes = mealTypes.filter(item => showObj[`mealShow${item.id}`] === true)// 去除出院时间冲突的餐次后选中最近的，没有就是空
    defaultMealType = newMealtypes.length ? newMealtypes[0].id : ''
  } else {
    defaultMealType = ''
  }
  // console.log(enAbleMealTypes)
  return defaultMealType
}
// 获取不可以点的餐次id
export function getDisableMealTypes (OrderMark) {
  const disableMealTime = []
  const dt = new Date()
  const year = addZero(dt.getFullYear(), 4)
  const month = addZero(dt.getMonth() + 1, 2)
  const day = addZero(dt.getDate(), 2)
  const hour = addZero(dt.getHours(), 2)
  const minute = addZero(dt.getMinutes(), 2)
  const second = addZero(dt.getSeconds(), 2)
  const date = year + '/' + month + '/' + day
  const time = hour + ':' + minute + ':' + second
  const nowDateTimeObj = new Date(date + ' ' + time)
  // console.log(date)
  OrderMark.mealtypes.forEach(item => {
    // console.log(item)
    const mealDateTimeObj = new Date(date + ' ' + item.orderDeadLine)
    if (nowDateTimeObj.getTime() >= mealDateTimeObj.getTime()) {
      disableMealTime.push(item.id)
    }
  })
  return disableMealTime
}
// 获取当天可以退餐的餐次id
export function getEnAbleCancelMealTypes (OrderMark) {
  const tmpEnableMeals = []
  const dt = new Date()
  const year = addZero(dt.getFullYear(), 4)
  const month = addZero(dt.getMonth() + 1, 2)
  const day = addZero(dt.getDate(), 2)
  const hour = addZero(dt.getHours(), 2)
  const minute = addZero(dt.getMinutes(), 2)
  const second = addZero(dt.getSeconds(), 2)
  const date = year + '/' + month + '/' + day
  const time = hour + ':' + minute + ':' + second
  const nowDateTimeObj = new Date(date + ' ' + time)
  OrderMark.mealtypes.forEach(item => {
    // console.log(item)
    const mealDateTimeObj = new Date(date + ' ' + item.reOrderDeadLine)
    if (nowDateTimeObj.getTime() < mealDateTimeObj.getTime()) {
      tmpEnableMeals.push(item.id)
    }
  })
  return tmpEnableMeals
}
/** *********测试当前所点的餐次中是否存在不可以点的餐次，存在则返回false，否可以点则返回true****** */
function testOrderFood (OrderInfo, OrderMark, advanceDay, setModalInfo) {
  const tmpEnableOrderDate = OrderMark.orderDateList.map(item => item.replace(/[-]/g, ''))
  let flag = 'success'
  // let tmpMealname = ''
  const date = getDateStr(advanceDay) // 获取今天+props.advanceDay的日期
  const disableMealTime = getDisableMealTypes(OrderMark)
  // console.log(disableMealTime)
  // console.log(tmpEnableOrderDate)
  const tmpOrderInfo = OrderInfo.cacheAllFoodList.map(item => {
    if (item.allowOrder !== 'error_Invalid' && item.allowOrder !== 'error_soldOut' && item.allowOrder !== 'error_alreadyOrder' && item.allowOrder !== 'error_limitOne' && item.allowOrder !== 'error_patientNoOrder' && item.allowOrder !== 'error_prepareBySelf') {
      item.allowOrder = 'allow'
    }
    if (item.selectedQuantity !== 0) {
      if (item.dayTime) {
        if (!tmpEnableOrderDate.includes(item.dayTime.substr(0, 10).replace(/[-]/g, ''))) {
          if (!flag.includes('error') || flag === 'error_notInAllowDate') {
            flag = 'error_notInAllowDate' // 不在可点餐日期之内
            item.allowOrder = 'error_notInAllowDate'
            setModalInfo(intl.get('Some meals are not within the order date, please choose again.'))
          }
        } else {
          if (Number(item.dayTime.substr(0, 10).replace(/[-]/g, '')) < Number(date.substr(0, 10).replace(/[/]/g, '')) ||
            ((Number(item.dayTime.substr(0, 10).replace(/[-]/g, '')) === Number(date.substr(0, 10).replace(/[/]/g, ''))) && disableMealTime.includes(item.mealTypeID))
          ) {
            if (!flag.includes('error') || flag === 'error_outToDate') {
              flag = 'error_outToDate' // 所点餐次过了点餐截止时间
              item.allowOrder = 'error_outToDate'
              setModalInfo(intl.get('Some meals exceeded the order deadline, please choose again.'))
            }
          }
          // 由于更改PFS修改出院时间，当前页面并不会重新读取，所以前端校验是不靠谱的，这个依赖后端校验
          // else if (item.allowOrder === 'error_Invalid') { // 此报错是orderDedined页面调用接口返回时候设置
          //   if (!flag.includes('error') || flag === 'error_Invalid') {
          //     flag = 'error_Invalid'
          //     OrderMark.mealtypes.forEach(itemData => { itemData.id === item.mealTypeID && (tmpMealname = itemData.mealName) })
          //     const tmpMessage = item.dayTime.substr(0, 10) + ' ' + tmpMealname + ' ' + intl.get("delivery time is after the discharge time, you can't order this meal.")
          //     setModalInfo(tmpMessage)
          //   }
          // } else if (item.allowOrder === 'error_soldOut') { // 此报错是orderDedined页面调用接口返回时候设置
          //   if (!flag.includes('error') || flag === 'error_soldOut') {
          //     flag = 'error_soldOut'
          //     OrderMark.mealtypes.forEach(itemData => { itemData.id === item.mealTypeID && (tmpMealname = itemData.mealName) })
          //     const tmpMessage = item.dayTime.substr(0, 10) + ' ' + tmpMealname + ' ' + item.foodName + ' ' + intl.get('It is sold out. Please re-select it.')
          //     setModalInfo(tmpMessage)
          //    }
          // }
        }
      }
    }
    // console.log(item)
    return item
  })
  OrderInfo.setCacheAllFoodList(tmpOrderInfo)
  return flag
}
// 当点击结算的时候要将已经点的餐次食物信息写入后端缓存接口
export function writeToCacheIface (writtenBtn, OrderInfo, OrderMark, Language, setShowModal, setModalInfo, setShowCancelButton, props, setIsshow) {
  if (!(typeof (OrderMark.position) === 'string' && OrderMark.position)) {
    // 如果床位信息不是字符串或者是空字符串就不能点餐
    setModalInfo(intl.get('The patient bed information is empty, no ordering.'))
    setShowModal(true)
    return false
  }
  writtenBtn.current.disabled = true
  let tmpFlag = 'success'
  if (!OrderInfo.cacheAllFoodList || OrderInfo.cacheAllFoodList.length === 0) { // 缓存为空，说明用户没点餐，不允许写入缓存订单，不允许跳转页面
    setShowCancelButton(false)
    setShowModal(true)
    writtenBtn.current.disabled = false
    setModalInfo(intl.get('You have not chosen any dishes yet.'))
    return false
  }
  const result = []
  tmpFlag = testOrderFood(OrderInfo, OrderMark, props.advanceDay, setModalInfo)
  if (tmpFlag.includes('error')) {
    setShowCancelButton(false)
    setShowModal(true)
    writtenBtn.current.disabled = false
    setIsshow(true)
    return false
  } else {
    // 过滤出那些数量大于0的食物(客户要求显示0)
    const tmp = OrderInfo.cacheAllFoodList.filter(item => item.selectedQuantity > 0)
    if (tmp.length === 0) {
      setShowCancelButton(false)
      setShowModal(true)
      writtenBtn.current.disabled = false
      setModalInfo(intl.get('You have not chosen any dishes yet.'))
      return false
    }
    tmp.forEach(item => {
      // console.log(item)
      const tmpObj = {
        dayTime: item.dayTime,
        foodID: item.foodID,
        isPotFood: item.isPotFood,
        mealTypeID: item.mealTypeID,
        selectedQuantity: item.selectedQuantity,
        typeID: item.typeID,
        isSpecialAdvice: item.isSpecialAdvice
      }
      if (item.isPotFood === false) {
        tmpObj.sort = item.sort
        tmpObj.foodMenuID = tmpObj.isSpecialAdvice ? '' : item.foodMenuID
      } else {
        tmpObj.potFoodID = item.potFoodID
      }
      result.push(tmpObj)
    })
    // console.log(OrderInfo.cacheAllFoodList)
    console.log('写入后端缓存的数据')
    console.log(result)
    console.log('===================')
    request(`/v1/order/cache`, {
      method: 'POST',
      headers: {
        'Accept-Language': Language.acceptLanguage
      },
      body: result
    }).then((res) => {
      if (res.error) {
        writtenBtn.current.disabled = false
        setShowCancelButton(false)
        setShowModal(true)
        setModalInfo(res.message)
      } else {
        props.history.push('/order/orderDefined')
      }
    }).catch((error) => {
      console.log(error)
    })
  }
}
// 当当OrderInfo的食物更新时重新计算总价格
export function updatePrice (OrderInfo, OrderPrice) {
  let tmpPrice = 0
  OrderInfo.cacheAllFoodList.forEach(item => {
    if (item.unitPrice >= 0 && item.selectedQuantity >= 0) {
      tmpPrice += Math.round(parseFloat(item.unitPrice * 100 * item.selectedQuantity)) / 100
    }
  })
  // console.log(tmpPrice)
  OrderPrice.setPrice(tmpPrice)
}
// 当OrderInfo的食物医院配置是否包伙制，确定营养餐是否出院结算，重新计算实际需要支付的总价格
// 小锅菜是否需要付钱，需要根据是否写入his来确定，写入则不收钱且不能退款
// 营养餐包伙制，不写入his，微信不收钱，可以退餐
// 营养餐包伙制，写入his，微信不收钱，不可以退餐
// 营养餐非包伙制，微信收钱，可以退餐
export function updatePayPrice (OrderInfo, OrderMark, OrderPrice) {
  let tmpPrice = 0
  OrderInfo.cacheAllFoodList.forEach(item => {
    // console.log(OrderMark.properties)
    if (!isObjEmpty(OrderMark.properties)) {
      if (item.isPotFood === true) {
        if (!OrderMark.properties.isPotFoodWriteHis) {
          tmpPrice += Math.round(parseFloat(item.unitPrice * 100 * item.selectedQuantity)) / 100
        }
      } else {
        if (!OrderMark.properties.isFoodGang) {
          tmpPrice += Math.round(parseFloat(item.unitPrice * 100 * item.selectedQuantity)) / 100
        }
      }
    }
  })
  // console.log(tmpPrice)
  OrderPrice.setPayPrice(tmpPrice)
}
// 当OrderInfo的食物更新要重新计算一下包伙制的营养餐和小锅菜的价格
export function updateYyXgPrice (OrderInfo, OrderPrice) {
  let tmpYyPrice = 0
  let tmpXgPrice = 0
  OrderInfo.cacheAllFoodList.forEach(item => {
    if (!item.isPotFood) {
      tmpYyPrice += Math.round(parseFloat(item.unitPrice * 100 * item.selectedQuantity)) / 100
    } else {
      tmpXgPrice += Math.round(parseFloat(item.unitPrice * 100 * item.selectedQuantity)) / 100
    }
  })
  OrderPrice.setYyPrice(tmpYyPrice)
  OrderPrice.setXgPrice(tmpXgPrice)
}
/***********************************************/
/** *********订餐确认页面OrderDefined.js*********/
/***********************************************/
// 测试所点的菜品中是否包含包伙制的餐次
export function checkIsContainPotFood (OrderInfo, OrderMark, OrderPrice) {
  const yyPotStatus = !isObjEmpty(OrderMark.properties) && OrderMark.properties.isFoodGang // 医院包伙制==>代表营养餐是出院结算的
  const xgPotStatus = !isObjEmpty(OrderMark.properties) && OrderMark.properties.isPotFoodWriteHis // 写入his则代表小锅菜出院结算
  // console.log(OrderMark)
  // console.log(yyPotStatus)
  // console.log(xgPotStatus)
  let tmpIsYyPot = false
  let tmpIsXgPot = false
  if (yyPotStatus || xgPotStatus) {
    OrderInfo.cacheAllFoodList.forEach(item => {
      if (item.selectedQuantity > 0) {
        if (!item.isPotFood && yyPotStatus) {
          tmpIsYyPot = true
        }
        if (item.isPotFood && xgPotStatus) {
          tmpIsXgPot = true
        }
      }
    })
  }
  OrderPrice.setIsYyPot(tmpIsYyPot)
  OrderPrice.setIsXgPot(tmpIsXgPot)
}
// 点击确认支付的时候调用后端付钱接口
export function payOrderMeals (BottonRef, OrderInfo, OrderPrice, OrderMark, Language, setIsshow, setShowModal, setModalInfo, history, advanceDay) {
  // console.log(history)
  BottonRef.current.disabled = true
  let tmpFlag = 'success'
  const orderFood = []
  // 过滤掉数量为0的食物
  const tmp = OrderInfo.cacheAllFoodList.filter(item => item.selectedQuantity > 0)
  tmp.forEach(item => {
    const tmpFoodItem = {}
    tmpFoodItem.dayTime = item.dayTime
    tmpFoodItem.foodID = item.foodID
    tmpFoodItem.isPotFood = item.isPotFood
    tmpFoodItem.mealTypeID = item.mealTypeID
    tmpFoodItem.selectedQuantity = item.selectedQuantity
    if (item.isSpecialAdvice) {
      tmpFoodItem.isSpecialAdvice = item.isSpecialAdvice
    }
    if (item.isPotFood === false) {
      tmpFoodItem.sort = item.sort
      tmpFoodItem.foodMenuID = tmpFoodItem.isSpecialAdvice ? '' : item.foodMenuID
    } else {
      tmpFoodItem.potFoodID = item.potFoodID
    }
    tmpFoodItem.typeID = item.typeID
    orderFood.push(tmpFoodItem)
  })
  console.log(orderFood)
  const payPrice = Math.round(parseFloat(OrderPrice.payPrice * 100))
  if (tmp.length <= 0) {
    setIsshow(false)
    setShowModal(true)
    BottonRef.current.disabled = false
    setModalInfo(intl.get('You have not chosen any dishes yet.'))
    return false
  }
  tmpFlag = testOrderFood(OrderInfo, OrderMark, advanceDay, setModalInfo)
  if (tmpFlag.includes('error')) {
    setIsshow(false)
    setShowModal(true)
    BottonRef.current.disabled = false
    return false
  } else {
    request(`/v1/order/init?frontPrice=${payPrice}`, {
      method: 'POST',
      headers: {
        'Accept-Language': Language.acceptLanguage
      },
      body: orderFood
    }).then((res) => {
      if (res.error) {
        BottonRef.current.disabled = false
        let tmpMessage = res.message + intl.get('contactDietitian')
        let tmpMealname = ''
        if (res.code === '1001' || res.code === '1002' || res.code === '1007' || res.code === '1008' || res.code === '1010') {
          const messageObj = JSON.parse(res.message)
          if (messageObj.isPotFood === false) {
            messageObj.checkId = messageObj.isSpecialAdvice ? 'specialFoodId' : messageObj.foodMenuID
          } else {
            messageObj.checkId = messageObj.potFoodID
          }
          // console.log(messageObj)
          // console.log(messageObj.dayTime)
          const tmpOrderInfo = OrderInfo.cacheAllFoodList.map(item => {
            // console.log(item)
            item.allowOrder = 'allow'
            if (messageObj.dayTime && item.dayTime && messageObj.dayTime.substr(0, 10).replace(/[-]/g, '') === item.dayTime.substr(0, 10).replace(/[-]/g, '') && messageObj.mealTypeID === item.mealTypeID) {
              OrderMark.mealtypes.forEach(itemData => { itemData.id === messageObj.mealTypeID && (tmpMealname = itemData.mealName) })
              if (res.code === '1001' || res.code === '1002') {
                messageObj.checkId === item.checkId && (item.allowOrder = 'error_soldOut') // 所点菜品已经售完
                tmpMessage = item.dayTime.substr(0, 10) + ' ' + tmpMealname + ' ' + item.foodName + ' ' + intl.get('It is sold out. Please re-select it.')
              } else if (res.code === '1007') {
                item.allowOrder = 'error_alreadyOrder' // 所点菜品送餐时间超过了出院时间
                tmpMessage = item.dayTime.substr(0, 10) + ' ' + tmpMealname + ' ' + intl.get('meal package has been ordered.')
              } else if (res.code === '1008') {
                item.allowOrder = 'error_Invalid' // 所点菜品送餐时间超过了出院时间
                tmpMessage = item.dayTime.substr(0, 10) + ' ' + tmpMealname + ' ' + intl.get("delivery time is after the discharge time, you can't order this meal.")
              } else if (res.code === '1010') {
                item.allowOrder = 'error_limitOne' // 所点菜品送餐时间超过了出院时间
                tmpMessage = item.dayTime.substr(0, 10) + ' ' + tmpMealname + ' ' + intl.get('limit one serving.')
              }
            }
            return item
          })
          tmpOrderInfo.length > 0 && OrderInfo.setCacheAllFoodList(tmpOrderInfo)
        } else if (res.code === '1003') {
          tmpMessage = intl.get('Some meals exceeded the order deadline, please choose again.')
        } else if (res.code === '1004') {
          tmpMessage = intl.get('Limit one serving per meal for the same type of food.')
        } else if (res.code === '1009') {
          tmpMessage = intl.get('The patient bed information is empty and cannot be ordered.')
        } else if (res.code === '1011') {
          const tmpNoOrderInfo = OrderInfo.cacheAllFoodList.map(item => {
            !item.isPotFood && (item.allowOrder = 'error_patientNoOrder')
            return item
          })
          tmpNoOrderInfo.length > 0 && OrderInfo.setCacheAllFoodList(tmpNoOrderInfo)
          tmpMessage = intl.get("Dietary advice is fasting, Patient can't order")
        } else if (res.code === '1012') {
          const tmpNoOrderInfo = OrderInfo.cacheAllFoodList.map(item => {
            !item.isPotFood && (item.allowOrder = 'error_prepareBySelf')
            return item
          })
          tmpNoOrderInfo.length > 0 && OrderInfo.setCacheAllFoodList(tmpNoOrderInfo)
          tmpMessage = intl.get("The dietician's advice is to take care of themselves, and the patient can't order food")
        }
        setIsshow(false)
        setShowModal(true)
        setModalInfo(tmpMessage)
        OrderInfo.setCacheAllFoodList([])
      } else {
        console.log(res)
        if (res.data === '0') {
          history.push('/historicalOrders')
        } else {
          const tmpurl = res.data
          if (res.data !== '') {
            const url = encodeURI(tmpurl).replace('#', '%23')
            window.location.href = url
          }
        }
        OrderInfo.setCacheAllFoodList([])
      }
    }).catch((error) => {
      console.log(error)
    })
  }
}
// 当进入OrderDefined.js页面的时候要写入后端缓存
export function readFromCacheIface (OrderInfo, Language, setShowModal, setModalInfo) {
  request(`/v1/order/cache`, {
    method: 'GET',
    headers: {
      'Accept-Language': Language.acceptLanguage
    }
  }).then((res) => {
    if (res.error) {
      setShowModal(true)
      setModalInfo(res.message)
    } else {
      // console.log(res.data)
      const tmpData = deepCopy(res.data)
      let tmpCacheFoodList = []
      if (tmpData.length > 0) {
        tmpCacheFoodList = tmpData.map(itemDatas => {
          itemDatas.allowOrder = 'allow'
          itemDatas.num = itemDatas.num === null ? 0 : itemDatas.num
          itemDatas.totalNum = itemDatas.totalNum === null ? -1 : itemDatas.totalNum
          if (itemDatas.isPotFood === false) {
            // 只有营养餐的时候才可能出现特殊饮食，因为营养餐是给病人吃的。
            itemDatas.checkId = itemDatas.isSpecialAdvice ? itemDatas.foodID : itemDatas.foodMenuID
          } else {
            itemDatas.checkId = itemDatas.potFoodID
          }
          return itemDatas
        })
      }
      // console.log(tmpCacheFoodList)
      OrderInfo.setCacheAllFoodList(tmpCacheFoodList)
    }
  }).catch((error) => {
    console.log(error)
  })
}
// 当useContext的值存在，读取useContext的值，更新一下日期并且排序。(OrderDefined.js和OrderShopping.js两个文件用到)
export function updateDate (OrderInfo, setDateArr) {
  const newDateArr = []
  OrderInfo.cacheAllFoodList.forEach(item => {
    const dateItem = parseInt(item.dayTime.substr(0, 10).replace(/[-]/g, ''))
    newDateArr.indexOf(dateItem) < 0 && newDateArr.push(dateItem)
  })
  newDateArr.sort((a, b) => a - b)
  const tmp = newDateArr.map(item => {
    const strItem = String(item)
    return strItem.substr(0, 4) + '-' + strItem.substr(4, 2) + '-' + strItem.substr(6, 2)
  })
  setDateArr(tmp)
}
// 当进入点餐页面时候，小锅菜默认选中第一个菜谱类别
export function getFirstXgType (xgFoodShowArr, xgFoodType, xgFoodlist, setXgActive, setShowXgFoodlist) {
  if(JSON.stringify(xgFoodShowArr) ==='{}'){
    
  }else{
    for (let i = 0; i < xgFoodType.length; i++)
    {
      if(xgFoodShowArr[`xgTypeShow${xgFoodType[i].id}`]){
        setXgActive(xgFoodType[i].id)
        setShowXgFoodlist(xgFoodlist.filter(item => {
          return item.food && item.food.type_ID === xgFoodType[i].id
        }))    
        break;
      }
    }
  }
}
// 当进入点餐页面时候，营养餐默认选中第一个菜谱类别
export function getFirstYyType (yyFoodShowArr, yyFoodType, yyFoodlist, setYyActive, setShowYyFoodlist) {
  // console.log('进入营养餐')
  // console.log('yyFoodShowArr',yyFoodShowArr)
  // console.log('yyFoodType',yyFoodType)
  // console.log('yyFoodlist',yyFoodlist)
  if(JSON.stringify(yyFoodShowArr) ==='{}'){
    
  }else{
    for (let i = 0; i < yyFoodType.length; i++)
    {
      if(yyFoodShowArr[`yyTypeShow${yyFoodType[i].id}`]){
        setYyActive(yyFoodType[i].id)
        setShowYyFoodlist(yyFoodlist.filter(item => {
          return item.type_ID === yyFoodType[i].id
        }))    
        break;
      }
    }
  }
  // console.log('营养餐结束')
}
